var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20.56 18.44-3.807-3.808A7.45 7.45 0 0 0 18 10.5C18 6.365 14.636 3 10.5 3 6.365 3 3 6.365 3 10.5c0 4.136 3.365 7.5 7.5 7.5 1.526 0 2.946-.46 4.132-1.247l3.808 3.808a1.5 1.5 0 1 0 2.12-2.121M5.25 10.5a5.256 5.256 0 0 1 5.25-5.25 5.256 5.256 0 0 1 5.25 5.25 5.256 5.256 0 0 1-5.25 5.25 5.256 5.256 0 0 1-5.25-5.25"
  })));
};
export default SvgSearch;